"use strict";

exports.__esModule = true;
exports.MetricValueAggregateFields = MetricValueAggregateFields;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Catalogs = require("../../../Catalogs");
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Core = require("../../Core");
var _Metrics = require("../../Metrics");
var _excluded = ["onChange", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var MetricSelectorAdaptor = function MetricSelectorAdaptor(_ref) {
  var onChange = _ref.onChange,
    value = _ref.value,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var selectedItem = value && (0, _Catalogs.getMetricDefinition)(value);
  return /*#__PURE__*/_react["default"].createElement(_Metrics.MetricSelector, _extends({
    onSelect: function onSelect(selected) {
      return onChange(selected.length > 0 ? selected[0].name : undefined);
    },
    selected: selectedItem ? [selectedItem] : []
  }, extra));
};

/**
 * Fields for MetricValueAggregateElement.
 */
function MetricValueAggregateFields(props) {
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref2) {
    var translate = _ref2.translate;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("MetricValueAggregateFields.metricName.label", "Metric")
    }, /*#__PURE__*/_react["default"].createElement(MetricSelectorAdaptor, {
      value: element.props.metricName,
      onChange: function onChange(value) {
        return elementEditor.setProp(path, "metricName", value);
      }
    })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("MetricValueAggregateFields.aggregate.label", "Aggregate")
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.HTML_SELECT
    }, /*#__PURE__*/_react["default"].createElement("select", {
      value: element.props.aggregationType,
      onChange: function onChange(e) {
        elementEditor.setProp(path, "aggregationType", e.target.value);
      }
    }, /*#__PURE__*/_react["default"].createElement("option", {
      value: "AVERAGE"
    }, translate("MetricValueAggregateFields.aggregate.average.label", "Average")), /*#__PURE__*/_react["default"].createElement("option", {
      value: "SUM"
    }, translate("MetricValueAggregateFields.aggregate.sum.label", "Sum"))))), /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutSettingsContext.Consumer, null, function (layoutSettings) {
      return layoutSettings.selection.allowReportingPeriod && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("MetricValueAggregateFields.dataRange.label", "Data Range"),
        helperText: translate("MetricValueAggregateFields.dataRange.helperText", "The data range to use when calculating the metric value.")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        value: element.props.dataRange || "",
        onChange: function onChange(e) {
          elementEditor.setProp(path, "dataRange", e.target.value || undefined);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: ""
      }, translate("MetricValueAggregateFields.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
        value: "SELECTION"
      }, translate("MetricValueAggregateFields.dataRange.selection.label", "Selection")))));
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: element.props.hideLabel || false,
      label: translate("MetricValueAggregateFields.hideLabel.label", "Hide Label"),
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "hideLabel", e.target.checked);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: element.props.includeDevicesIntoCalculation,
      label: translate("MetricValueAggregateFields.includeDevicesWithoutMetric.label", "Include zero/no value in metric calculation"),
      onChange: function onChange(e) {
        return elementEditor.setProp(path, "includeDevicesIntoCalculation", e.target.checked);
      }
    }));
  });
}